<template>
    <div class="login">
        <div class="login_img">
            <span>图油司机端</span>
        </div>
        <div class="login_form">
            <div>
                <span>手机号:</span>
                <input @blur="springback" v-model="mobile" style="border:none;" type="tel" placeholder="请输入手机号">
                <span class="obtain"></span>
            </div>
            <div>
                <span>验证码:</span>
                <input @blur="springback" v-model="code" type="tel" placeholder="请输入验证码">
                <span class="obtain" id="obtain_bt">{{btntxt}}</span>
            </div>
        </div>
        <div class="refer">
            <p>
                <input type="checkbox" checked>
                <span>我已经同意《加油服务协议》</span>
            </p>
            <div @click="submit" :class="[( mobile.trim().length>0) && (code.trim().length>0)  ? 'btn-green' : '' ]">
                登录
            </div>
        </div>
    </div>
</template>

<script>
    import {verify} from "../../static/gt"
    import common from "../common";

    export default {
        name: 'login',
        data() {
            return {
                login_bol: false,
                submit_bol: false,
                mobile: "",
                code: "",
                time: 0,
                btntxt: "获取验证码",
                ban: false,
                challenge_val: "",
                validate_val: "",
                seccode_val: "",
                openid: ""
            }
        },
        methods: {
            //验证手机号码部分
            validation() {
                const {mobile} = this;
                const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
                if (!mobile) {
                    common.toast("请输入手机号");
                } else if (!reg.test(mobile)) {
                    common.toast('手机号格式不正确');
                } else if (this.time > 0) {
                    common.toast("请在" + this.time + "秒后重试");
                } else {
                    return true;
                }
            },
            sendcode() {
                //发送验证码
                const {mobile} = this;
                let challenge_val = this.challenge_val;
                let validate_val = this.validate_val;
                let seccode_val = this.seccode_val;
                const type = "wxlogin";
                this.disabled = true;
                let querystring = require('querystring');
                this.$api.post("/wx/sendCode",
                    querystring.stringify({
                        mobile,
                        type,
                        challenge_val,
                        validate_val,
                        seccode_val
                    })
                ).then(data => {
                    if (data.data.status == 0) {
                        common.toast(data.data.msg);
                    } else {
                        this.time = 60;
                        this.timer();
                        common.toast("发送成功");
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            timer() {
                if (this.time > 0) {
                    this.time--;
                    this.btntxt = this.time + "s";
                    this.ban = true;
                    setTimeout(this.timer, 1000);
                } else {
                    this.ban = false;
                    this.time = 0;
                    this.btntxt = "获取验证码";
                }
            },
            submit() {
                if (this.code) {
                    let querystring = require('querystring');
                    this.$api.post('/wx/login',
                        querystring.stringify({
                            mobile: this.mobile,
                            code: this.code,
                            openid: this.openid
                        })
                    ).then(({data}) => {
                        if (data.status == 1) {
                            common.setlocalStorage("userInfo", JSON.stringify(data.data));
                            common.setDomainCookie("platform", "tiger",365);
                            this.$router.replace("/");
                        } else {
                            common.toast(data.msg);
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    common.toast("验证码不能为空");
                }
            },
            // 解决苹果不回弹页面
            blurAdjust(e) {
                setTimeout(() => {
                    if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
                        return
                    }
                    let result = 'pc';
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                        result = 'ios'
                    } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
                        result = 'android'
                    }

                    if (result = 'ios') {
                        document.activeElement.scrollIntoViewIfNeeded(true);
                    }
                }, 100)
            },
            //处理ioc编辑input框后,页面不弹回原来的样式;
            springback() {
                let u = navigator.userAgent, app = navigator.appVersion
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isIOS) {
                    this.blurAdjust();
                }
            },
            handler() {
                event.preventDefault();// 阻止默认的处理方式(阻止下拉滑动的效果)
            }
        },
        created() {
            this.openid = this.$route.query.openid || "";
            verify(window);
            let this_ = this;
            this_.$api.get('/GeetestStart').then(data => {
                initGeetest({
                    // 以下配置参数来自服务端 SDK
                    gt: data.data.gt,
                    challenge: data.data.challenge,
                    offline: !data.data.success,
                    new_captcha: true,
                    product: 'bind'
                }, function (captchaObj) {
                    captchaObj.onReady(() => {
                    })
                        .onSuccess(() => {
                            let result = captchaObj.getValidate();
                            if (!result) {
                                return alert('请完成验证');
                            }
                            this_.challenge_val = result.geetest_challenge;
                            this_.validate_val = result.geetest_validate;
                            this_.seccode_val = result.geetest_validate;
                            this_.sendcode();
                        })
                    document.querySelector("#obtain_bt").onclick = function () {
                        if (this_.validation()) {
                            captchaObj.verify(); //显示验证码
                        }
                    }
                })
            }).catch((err) => {
                common.toast(err);
            })
        },
        mounted() {
            // 绑定事件
            document.addEventListener('touchmove', this.handler, {passive: false});// passive 参数不能省略，用来兼容ios和android
        },
        destroyed() {
            // 解绑事件
            document.removeEventListener('touchmove', this.handler, {passive: false});
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .login {
        width: 100vw;
        height: 100vh;
        background: white;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        touch-action: none;
    }

    .login_img {
        width: 80vw;
        height: 5vh;
        margin: 50px auto;
        display: -webkit-flex;
        flex-direction: column;
        color: #9c9fad;
        font-size: .6rem;
    }

    .login_img > img {
        margin: 20px auto;
        width: auto;
        height: 20vh;
    }

    .login_form {
        width: 90vw;
        height: 25vh;
        margin: 0 auto;
        display: -webkit-flex;
        flex-direction: column;
        align-items: baseline;
        font-size: .6rem;
        color: #c5c5c9;
    }

    .login_form > div {
        flex: 1;
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: .01rem solid #e7e7e7;
    }

    .login_form > div > span {
        flex-wrap: nowrap;
    }

    .login_form > div {
        justify-content: space-between;
        flex-wrap: nowrap;
    }

    .obtain {
        width: 20vw;
        color: #c5c5c9;
        font-size: .4rem;
        text-align: -webkit-right;
        border: none;
        background: white;
    }

    .login_form input {
        outline: none;
        font-size: .6rem;
        color: black;
        border: none;
        width: 40vw;
    }

    .login_form input::-webkit-input-placeholder {
        color: #c5c5c9;
    }

    .refer {
        width: 90vw;
        height: 30vh;
        margin: 2vw auto;
        display: -webkit-flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: flex-start;
        color: #c5c5c9;
    }

    .refer input {
        width: 10vw;
    }

    .refer p {
        font-size: .5rem;
    }

    .refer p, .refer input {
        vertical-align: bottom;
    }

    .refer div {
        width: 100%;
        height: 8vh;
        background: #c5c5c9;
        line-height: 8vh;
        border-radius: 10px;
        color: white;
        font-size: .6rem;
        margin-top: 5vh;
    }

    .refer .btn-green {
        background-color: #1aad19;
        color: #fff;
    }

    .mint-toast-text {
        font-size: .6rem;
    }

    .addClass {
        padding: 20px !important;
    }

    .addClass > span {
        padding-top: 0 !important;
    }
</style>
      


// WEBPACK FOOTER //
// src/components/login.vue